import { CONVERSION_FACTORS, MATERIAL_CONSTANTS } from '../constants/calculator_constants';
import { kpsiToGPa, gpaToKpsi } from '../utility/convert_stress';

export type ForceResult = {
  force: number;
  strainPercent: number;
};

export function computeGramsFromKpsi(
  kpsi: number,
  diameterMicrons: number,
  decimalsKpsi = 0,
  youngsModulus = MATERIAL_CONSTANTS.E0_MPA
): ForceResult {
  const radiusMeters = ((diameterMicrons / 1000000)) / 2;

  const kpsiToMpa = decimalsKpsi === 0 ? kpsi * CONVERSION_FACTORS.KSI_TO_MPA : kpsi * Number((CONVERSION_FACTORS.KSI_TO_MPA).toFixed(decimalsKpsi));

  const force = kpsiToMpa * 1000000 * (1000 * Math.PI * (radiusMeters * radiusMeters)) / CONVERSION_FACTORS.GRAVITY;

  const strainPercent = kpsi * CONVERSION_FACTORS.KSI_TO_MPA / youngsModulus * 100; 
  return {
    force: Number(force),
    strainPercent: Number(strainPercent),
  };
}

export default computeGramsFromKpsi;